<template>
  <v-dialog v-model="visible" :max-width="width" @keydown.esc="reject()" @keydown.enter="accept()" persistent>
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope" />
    </template>
    <v-card>
      <v-card-title class="headline">
        <v-spacer></v-spacer>
        {{ caption }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <h2 class="title mb-3">{{ heading }}</h2>
        <v-row>
          <v-col>
            <p>{{ message }}. Keep playing and soon you will have learned {{ total_terms }} terms!</p>
            <p>
              The database was: <strong>{{ database.toUpperCase() }} </strong> and your time was <strong>{{ timer }}</strong> seconds.
            </p>
            <p>The greek term was:</p>
            <p class="title text-center">{{ term["GR"] }}</p>
            <p>The english term was:</p>
            <p class="title text-center">{{ term["EN"] }}</p>
            <p>
              Do you want to share this entry?
            </p>
            <share-area :url="term_uri" :buttonMode="false" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col lg="12" md="12" class="d-flex justify-center align-center">
            <v-btn color="warning" @click="reject()">close</v-btn>
            <v-btn color="success" @click="accept()">Play again</v-btn>
          </v-col>
          <v-col lg="12" md="12">
            <v-expansion-panels inset v-model="metadata_visible">
              <v-expansion-panel>
                <v-expansion-panel-header>Show me details about this term</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <code>{{ metadata }}</code>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ShareArea from "@/components/areas/ShareArea";

export default {
  components: {
    ShareArea
  },
  props: {
    acceptPrompt: {
      type: String,
      required: false,
      default: "Play again"
    },
    rejectPrompt: {
      type: String,
      required: false,
      default: "Let me check the results"
    }
  },
  computed: {
    caption() {
      if (this.win) {
        return "You made it!";
      } else {
        return "Oooops :(";
      }
    },
    heading() {
      if (this.win) {
        return "Congratulations!!!";
      } else {
        return "Nice try!!!";
      }
    },
    message() {
      if (this.win) {
        return "That was great work! you found the terms. Now Nicomachus is a little bit smarter!";
      } else {
        return "Nice try but you could do better! Maybe that wasn't easy!";
      }
    }
  },
  data() {
    return {
      width: 540,
      visible: false,
      value: "",
      text: "",
      promise: null,
      promiseResolve: null,
      promiseReject: null,
      win: false,
      timer: 0,
      term: {
        GR: "",
        EN: ""
      },
      database: "",
      metadata: "",
      metadata_visible: false,
      term_uri: "unknown",
      total_terms: 0
    };
  },
  methods: {
    open(win, termgr, termen, database, metadata, term_uri, timer, total_terms) {
      this.win = win;
      this.term_uri = term_uri;
      this.metadata = metadata;
      this.database = database;
      this.term["GR"] = termgr;
      this.term["EN"] = termen;
      this.timer = timer;
      this.visible = true;
      this.total_terms = total_terms;
      this.promise = new Promise((resolve, reject) => {
        this.promiseResolve = resolve;
        this.promiseReject = reject;
      });
      return this.promise;
    },
    accept() {
      this.visible = false;
      this.metadata_visible = false;
      this.promiseResolve(this.value);
    },
    reject() {
      this.visible = false;
      this.metadata_visible = false;
      this.promiseReject(this.value);
    }
  }
};
</script>
